const $button = $('.categories-box button');

$button.click(() => {
    $('.categories-box .list7').removeClass('-collapsed');
    $button.remove();
});
